module.exports = __webpack_public_path__ + "static/man2-7c096e1ff4d7e43ee42a4cb157fa3d0c.png";